(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sada-product-description"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = (value) => value.replace(/[^\p{L}\p{N}]/gu, '').toLowerCase();
  const enhance = () => {
    document.querySelectorAll('.product__description .sada-spec-table:not([data-spec-checked])').forEach((wrapper) => {
      wrapper.dataset.specChecked = 'true';
      const table = wrapper.querySelector(':scope > table');
      if (!table || table.querySelector('table, img, video, iframe, input, button, a')) return;
      const rows = Array.from(table.rows);
      if (rows.length < 2) return;
      const grid = [];
      rows.forEach((row, rowIndex) => {
        grid[rowIndex] ||= [];
        let column = 0;
        Array.from(row.cells).forEach((cell, cellIndex) => {
          while (grid[rowIndex][column]) column += 1;
          const value = { text: (cell.innerText || cell.textContent).replace(/\s+/g, ' ').trim(), source: `${rowIndex}:${cellIndex}` };
          const rowSpan = cell.rowSpan === 0 ? rows.length - rowIndex : cell.rowSpan;
          for (let y = rowIndex; y < Math.min(rows.length, rowIndex + rowSpan); y += 1) {
            grid[y] ||= [];
            for (let x = column; x < column + cell.colSpan; x += 1) grid[y][x] = value;
          }
          column += cell.colSpan;
        });
      });
      const columns = Math.max(...grid.map((row) => row.length));
      if (columns < 3 || grid.some((row) => row.length !== columns || Array.from({ length: columns }, (_, i) => row[i]).some((cell) => !cell))) return;
      const headers = grid[0].map((cell) => cell.text);
      if (headers.some((header) => !header) || new Set(headers).size !== headers.length) return;
      const modelsAcross = headers.slice(1).every((header) => /\d/.test(header));
      const groups = modelsAcross
        ? headers.slice(1).map((name, index) => ({ name, pairs: grid.slice(1).map((row) => ({ label: row[0].text, value: row[index + 1] })) }))
        : grid.slice(1).map((row) => ({ name: row[0].text, pairs: row.slice(1).map((value, index) => ({ label: headers[index + 1], value })) }));
      const cards = document.createElement('div');
      cards.className = 'sada-spec-cards';
      const label = document.createElement('p');
      label.className = 'sada-spec-cards-label';
      label.textContent = headers[0];
      cards.append(label);
      const productTitle = normalize(wrapper.dataset.productTitle || '');
      const matching = groups.findIndex((group) => productTitle.includes(normalize(group.name)));
      groups.forEach((group, index) => {
        const details = document.createElement('details');
        details.className = 'sada-spec-card';
        details.open = index === (matching >= 0 ? matching : 0);
        const summary = document.createElement('summary');
        summary.textContent = group.name;
        const list = document.createElement('dl');
        group.pairs.forEach((pair) => {
          const item = document.createElement('div');
          item.className = 'sada-spec-pair';
          item.dataset.specSource = pair.value.source;
          const term = document.createElement('dt');
          const definition = document.createElement('dd');
          term.textContent = pair.label;
          definition.textContent = pair.value.text;
          item.append(term, definition);
          list.append(item);
        });
        details.append(summary, list);
        cards.append(details);
      });
      wrapper.append(cards);
      wrapper.classList.add('sada-spec-table--cards');
      wrapper.removeAttribute('tabindex');
    });
  };
  const start = () => {
    enhance();
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; enhance(); });
    });
    document.querySelectorAll('product-info').forEach((root) => observer.observe(root, { childList: true, subtree: true }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', enhance);
})();
  } catch(e) { console.error(e); }
})();

})();
